import { useContext } from 'react'
import { Pressable, Text, View } from 'react-native'

import { cn } from '@/utils/cn'
import { CustomerService } from '@/components/icon'

import { CustomerServiceContext } from './providers/CustomerService'

function CustomerServiceButton({ isHome = false }: { isHome?: boolean }) {
  const { openChat, numUnread } = useContext(CustomerServiceContext)

  const hasNewMessage = numUnread > 0

  return (
    <Pressable className={'size-10 items-center justify-center'} onPress={openChat}>
      {({ pressed }) => (
        <>
          {hasNewMessage && (
            <View
              className={
                'absolute right-px top-px size-[17px] items-center justify-center rounded-full border border-white bg-danger'
              }
            >
              <Text className={'text-xs text-white'}>{numUnread}</Text>
            </View>
          )}
          <CustomerService
            className={cn('size-6', isHome ? 'text-white' : 'text-text-tertiary', pressed && 'opacity-50')}
          />
        </>
      )}
    </Pressable>
  )
}

export default CustomerServiceButton
